<template>
    <section class="thema-overzicht light purple">
        <v-circle-bg></v-circle-bg>
        <h1>Hier werkten we aan in 2020</h1>
        <p>In 2020 stond onze collectieve ambitie centraal: ‘Het realiseren van het beste onderwijs van Nederland’. Op basis van onze vijf strategische doelen maken we deze ambitie concreet.</p>

        <h3>Onze 5 strategische doelen</h3>

        <div class="list">
            <div class="point">
                <div class="number">1</div>
                <label>Aantoonbare <br/>onderwijs&shy;kwaliteit</label>
            </div>
            <div class="point" @click="$router.push('/Carriere')">
                <div class="number">2</div>
                <label>Opleiden voor <br/>een carri&egrave;re</label>
            </div>
            <div class="point" @click="$router.push('/Regio')">
                <div class="number">3</div>
                <label>Positie in <br class="hide-for-small" />de regio</label>
            </div>
            <div class="point" @click="$router.push('/Medewerker')">
                <div class="number">4</div>
                <label>Medewerker<br/>3.0</label>
            </div>
            <div class="point" @click="$router.push('/Duurzaam')">
                <div class="number">5</div>
                <label>Duurzaam <br/>verbeteren</label>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
    .text-btn{
        font-weight:900;
    }

    .meer-info{
        position:relative;
        width:100%;

        margin-bottom:2rem;

        &.open{
            background-color:#f4e1ef;
            box-shadow:0px 3px 4px rgba(0,0,0,0.1);

            button.text-btn{
                box-shadow:0px 3px 3px rgba( 0,0,0,0.15 );
            }
        }

        .abs-wrapper{
            position:absolute;
            // top:0;
            // left:0;
            width:100%;
            height:0;
            overflow:hidden;

            background-color:#f4e1ef;

            transition:height 0.3s ease-out;
        }
    }

    button.text-btn{
        position:relative;
        align-self:flex-start;
        display:block;
        width:100%;
        padding:0.5rem 0rem 1rem 1rem;
        text-align:left;
        background-color:#f4e1ef;

        transition: box-shadow 0.3s ease-out, top 0.3s ease-out;
    }
</style>

<script>
    import CircleBg from '@/app/components/circles';

    export default {
        name: 'GewerktOverzicht',
        meta: {
            title: 'GewerktOverzicht',
            color: '#a5147e'
        },
        components: {
            'v-circle-bg': CircleBg
        },

        data()
        {
            return {
                open: false,
                meerInfoHeight: 0
            };
        },

        beforeDestroy()
        {
            window.removeEventListener( 'resize', this.resizeRef );
        },

        mounted()
        {
            this.resizeRef = this.onResize;
            window.addEventListener( 'resize', this.resizeRef );
            this.onResize();
        },

        methods: {
            openMeerInfo()
            {
                this.open = !this.open;
            },

            onResize()
            {
                this.meerInfoHeight = 0;

                let kids = this.$el.querySelectorAll( '.abs-wrapper > *' );
                for( let i = 0; i < kids.length; i++ )
                {
                    this.meerInfoHeight += kids[i].getBoundingClientRect().height;
                }

                // 2.5x vmin 3.5
                this.meerInfoHeight += 2.5 * Math.min( window.innerWidth, window.innerHeight ) * 0.035;
            }
        }
    };
</script>
